export var createInitialStateLoading = function (bundleId) { return ({
    bundleId: bundleId,
    hasError: false,
    isLoaded: false,
    progress: 0,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/createInitialStateLoading.ts
// module id = 2231
// module chunks = 3